import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import { LocalStorage } from '~/web-frontend-core/base/LocalStorage';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
const LS_KEY = '~/web-frontend-core/store/line/matchesList/Matches';
/** Состояния матчей */
export class MatchesStates extends Subscribtion {
    constructor() {
        super(...arguments);
        this.unfoldedMatches = new Set();
        this.favoriteMatches = new Set((LocalStorage.restore(LS_KEY) || []).map(Number));
        this.small_display_invisible = {};
        this.data = {};
        this._onFavorite = () => void 0;
        //#region fold
        this.isUnfoldedMatch = (matchID) => this.unfoldedMatches.has(matchID);
        this.foldMatch = (matchID, isFolded) => {
            isFolded ?
                this.unfoldedMatches.delete(matchID) :
                this.unfoldedMatches.add(matchID);
            this.notify(matchID);
        };
        //#endregion
        //#region favorite
        this.isFavoriteMatch = (matchID) => this.favoriteMatches.has(matchID);
        this.favoriteMatch = (matchID, isFavorite = !this.favoriteMatches.has(matchID)) => {
            isFavorite ?
                this.favoriteMatches.add(matchID) :
                this.favoriteMatches.delete(matchID);
            this.store();
            this._onFavorite(matchID, isFavorite);
            this.notify(matchID);
        };
    }
    getData(filter) {
        if (filter && filter.isFavorite) {
            const favoriteMatchIDs = Array.from(this.favoriteMatches.values());
            return objectFromEntries(favoriteMatchIDs.map((matchID) => [matchID, this.data[matchID]]));
        }
        return this.data;
    }
    update(data, headTables) {
        objectEntries(data)
            .map(([matchID, match]) => [Number(matchID), match])
            .forEach(([matchID, match]) => {
            var _a;
            this.data[matchID] = Object.assign(this.data[matchID] || {}, match);
            if ('mainLineColsVis' in match) {
                this.small_display_invisible[matchID] = (match.mainLineColsVis || []).map((vis) => vis.i);
            }
            if ('htId' in match) {
                this.small_display_invisible[matchID] = (((_a = headTables === null || headTables === void 0 ? void 0 : headTables[match === null || match === void 0 ? void 0 : match.htId]) === null || _a === void 0 ? void 0 : _a.mainLineColsVis) || []).map((vis) => vis.i);
            }
            if ('mainLine' in match) {
                this.small_display_invisible[matchID].forEach((i) => {
                    match.mainLine[i].additionalClassName = 'small_display_invisible';
                });
            }
        });
        this.notify();
    }
    clear() {
        this.favoriteMatches.clear();
        this.unfoldedMatches.clear();
        this.data = {};
        this.store();
    }
    hasFavorite() {
        return this.favoriteMatches.size > 0;
    }
    setFavorite(matchIDs) {
        this.favoriteMatches = new Set(matchIDs);
    }
    onFavorite(callback) {
        this._onFavorite = callback;
    }
    //#endregion
    store() {
        LocalStorage.store(LS_KEY, Array.from(this.favoriteMatches.values()));
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/matchesList/Matches.js